import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withRouter, Link } from 'react-router-dom';
import ReactWOW from 'react-wow';

import {
  Row,
  Col,
  Media,
  Input,
  Button,
} from 'reactstrap';

import wineLogo1 from '../../../../assets/images/BusinessHomepage/WGE Case study/Balfour-RGB_Full-Vertical-Center-ColourL.avif';
import wineLogo2 from '../../../../assets/images/BusinessHomepage/WGE Case study/Biddenden-Heart-WHite NEW 2.avif';
import wineLogo3 from '../../../../assets/images/BusinessHomepage/WGE Case study/chapeldown-logo-1.avif';
import wineLogo4 from '../../../../assets/images/BusinessHomepage/WGE Case study/Gusbourne White.avif';
import wineLogo5 from '../../../../assets/images/BusinessHomepage/WGE Case study/Simpsons logo white grey.avif';
import wineLogo6 from '../../../../assets/images/BusinessHomepage/WGE Case study/squerryes-white.avif';
import wineLogo7 from '../../../../assets/images/BusinessHomepage/WGE Case study/Westwell_Wines_250x_2x WHITE.avif';
import wineLogo8 from '../../../../assets/images/BusinessHomepage/WGE Case study/yotes-court-vineyard-logo.avif';


import WGEImage from '../../../../assets/images/BusinessHomepage/WGE Case study/wgemap.png';
import WGELogo from '../../../../assets/images/BusinessHomepage/WGE Case study/WGElogo.png';

class WGECaseStudy extends Component {
  static propTypes = {
  };

  static defaultProps = {
    user: {},
  };

  constructor(props) {
    super(props);

    this.state = {
      error: null,
      salesValue: 15000,
      commission: 15,
      fees: 1000,
    };
  }

  componentDidMount() {
    const { user } = this.props;

  }

  render() {
    const { user } = this.props;
    const {
      salesValue, fees, commission,
    } = this.state;

    return (
      <>
        <section className="categories case-study style2">
          <div className="container" style={{ position: 'relative' }}>
            <ReactWOW animation='fadeInUp' delay=".4s">
              <Row style={{ minHeight: 312 }}>
                <Col xs="12" md="6" className="case-study-left">
                  <Media className="case-study-left-image" src={WGEImage} alt="#" />

                  <Media className="case-study-left-logo" src={WGELogo} alt="#" />
                </Col>
                <Col xs="12" md="6" className="case-study-right">
                  <div>
                    <div className="case-study-right-text case-study-right-text-1">
                      <p>
                        <div className="case-study-right-quotetion-mobile">”</div>
                        Using Steppr allowed us to quickly create a streamlined voucher sales process and provided new customers with a delightful gifting experience.
                      </p>
                    </div>
                    <div className="case-study-right-text2">
                      <b>Jo Ginn</b>, Brand Manager, Wine Garden of England
                    </div>
                    <div className="case-study-right-quotetion">”</div>
                    
                  </div>
                </Col>
                <div>
                  <div className="case-study-logos">
                    <a className="case-study-logos-logo">
                      <Media src={wineLogo1} alt="#" />
                    </a>
                    <a className="case-study-logos-logo">
                      <Media src={wineLogo2} alt="#" />
                    </a>
                    <a className="case-study-logos-logo">
                      <Media src={wineLogo3} alt="#" />
                    </a>
                    <a className="case-study-logos-logo">
                      <Media src={wineLogo4} alt="#" />
                    </a>
                    <a className="case-study-logos-logo">
                      <Media src={wineLogo5} alt="#" />
                    </a>
                    <a className="case-study-logos-logo">
                      <Media src={wineLogo6} alt="#" />
                    </a>
                    <a className="case-study-logos-logo">
                      <Media src={wineLogo7} alt="#" />
                    </a>
                    <a className="case-study-logos-logo">
                      <Media src={wineLogo8} alt="#" />
                    </a>
                  </div>
                </div>
              </Row>
            </ReactWOW>
            </div>
        </section>
      </>
    );
  }
}

export default withRouter(WGECaseStudy);
